import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import CloseRounded from '@material-ui/icons/CloseRounded';
import Popover from '@material-ui/core/Popover';
import makeStyles from '@material-ui/core/styles/makeStyles';
import _e from 'common/localeUtil';
import GMButton from './button/GMButton';

const useStyles = makeStyles((theme) => ({
	drawerHeader: {
		display: 'flex',
		justifyContent: 'flex-end',
		alignItems: 'center',
		flexDirection: 'row',
	},
	drawerFooter: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	closeIconStyle: {
		color: theme.palette.primary[700],
	},
	popoverRootStyle: {
		height: '100vh',
		width: 400,
		top: '0 !important',
		maxHeight: '100%',
		padding: theme.spacing(1),
		background: theme.palette.background.paper,
	},
}));

const EditorDrawerPanel = ({ anchorEl, handleClose, content }) => {
	const classes = useStyles();
	return (
		<Popover
			classes={{ paper: classes.popoverRootStyle }}
			open={Boolean(anchorEl)}
			anchorEl={anchorEl}
			anchorOrigin={{
				vertical: 'center',
				horizontal: 'right',
			}}
			transformOrigin={{
				vertical: 'center',
				horizontal: 'left',
			}}
		>
			<div className={classes.drawerHeader}>
				<IconButton onClick={handleClose} classes={{ root: classes.closeIconStyle }}>
					<CloseRounded />
				</IconButton>
			</div>
			{content}
			<div className={classes.drawerFooter}>
				<GMButton
					variant="contained"
					title={_e('confirm')}
					onClick={handleClose}
					color="primary"
				/>
			</div>
		</Popover>
	);
};

EditorDrawerPanel.propTypes = {
	handleClose: PropTypes.func,
	anchorEl: PropTypes.element,
	content: PropTypes.element,
};

export default EditorDrawerPanel;
